import axios from 'axios';

const adminUrl = process.env.VUE_APP_ADMIN_URL;

export default class PlanRankingService {
  /**
   * Obtiene el ranking de planes por contrato para un país y líneas de negocio.
   * @param {string} countryId - UUID del país (obligatorio).
   * @param {string[]} lineasNegocio - Líneas de negocio a incluir (repetidas como query param).
   * @returns {Promise<{status: string, data?: object}>}
   */
  static async getPlanRanking(countryId, lineasNegocio = []) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const params = new URLSearchParams();
      params.append('countryId', countryId);
      lineasNegocio.forEach(linea => params.append('lineaNegocio', linea));

      const response = await axios.get(`${adminUrl}/plan-ranking?${params.toString()}`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });

      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data.data };
      }
      return { status: 'error' };
    } catch (error) {
      return { status: 'error' };
    }
  }
}
